var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayLargeCustomCheckmark = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 4.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 10.4c8.174 0 15.574 3.313 20.93 8.67C66.287 24.426 69.6 31.826 69.6 40s-3.313 15.574-8.67 20.93C55.574 66.287 48.174 69.6 40 69.6s-15.574-3.313-20.93-8.67C13.713 55.574 10.4 48.174 10.4 40s3.313-15.574 8.67-20.93C24.426 13.713 31.826 10.4 40 10.4zm0 .533c-8.027 0-15.293 3.254-20.553 8.514-5.26 5.26-8.514 12.526-8.514 20.553 0 8.027 3.254 15.293 8.514 20.553 5.26 5.26 12.526 8.514 20.553 8.514 8.027 0 15.293-3.254 20.553-8.514 5.26-5.26 8.514-12.526 8.514-20.553 0-8.027-3.254-15.293-8.514-20.553-5.26-5.26-12.526-8.514-20.553-8.514z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M24.889 39.337 36.12 52.444l18.101-26.666"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayLargeCustomCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-large-custom-checkmark.222e810fb438daa77f2ff7233b51de98.svg";